import React from 'react';
import { Container } from 'react-bootstrap';
import './footer.scss';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
   const [translate] = useTranslation(['common']);

   return (
      <footer className="footer-custom bg-[#123D63] text-light mt-auto">
         <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 w-100 container-custom">
            <span className="small m-0">
               {translate('footer.reserved')}
            </span>
            <a href="https://ingenitiv.com/privacy-policy" className="link-light text-decoration-none"
               target="_blank" rel="noopener noreferrer"
            >
               {translate('footer.privacyPolicy')}
            </a>
         </Container>
      </footer>
   );
};

export default Footer;